import { Flex } from '@chakra-ui/react';
import { Text } from '@diamond/shared/ui';

export function LHCDetailFilterEmptyState() {
  return (
    <Flex direction="column" align="center" justify="center" py={20} gap={4}>
      <Text fontSize="lg" fontWeight="bold">
        Data tidak ditemukan
      </Text>
      <Text fontSize="sm" color="gray.500" textAlign="center">
        Tidak ada data yang sesuai dengan filter yang diterapkan
      </Text>
    </Flex>
  );
}
